'use client'

// Content Block Factories
import { cardGridFactory, linkDownloadGridBlock } from '../cardGrid'
import { introductionFactory } from '../introduction'
import { richTextBlockFactory } from '../richText'
import { mediaComponentFactory } from '../mediaComponent'
import { imageWithTextFactory } from '../imageWithText'
import { headingComponentFactory } from '../headingComponent'
import { cookieDeclarationFactory } from '../cookieDeclaration/cookieDeclarationFactory'
import { overviewBlockFactory } from '../overviewBlock'
import factCardSliderBlockFactory from '../factCardSliderBlock/FactCardSliderBlockFactory'
import { Cultures, PageTypes } from '@/types/enums'
import { callToActionFactory } from '../callToAction'
import { logoCarouselFactory } from '../logoCarousel'

function getContentBlock(
  blockData: any,
  index: number,
  pagePath: string,
  culture: Cultures,
  pageType?: PageTypes
) {
  let blockFactory
  switch (blockData?.content?.contentType) {
    case 'cardGrid':
      blockFactory = cardGridFactory(blockData, index)
      break
    case 'genericHero':
    case 'detailPageHero':
      blockFactory = headingComponentFactory(blockData, culture, index)
      break
    case 'richTextComponent':
      blockFactory = richTextBlockFactory(blockData, index)
      break
    case 'mediaComponent':
      blockFactory = mediaComponentFactory(blockData, index)
      break
    case 'introductionComponent':
      blockFactory = introductionFactory(blockData, index)
      break
    case 'linkDownloadGridBlock':
      blockFactory = linkDownloadGridBlock(blockData, index)
      break
    case 'cardGridBlock':
      blockFactory = cardGridFactory(blockData, index)
      break
    case 'imageWithTextBlock':
      blockFactory = imageWithTextFactory(blockData, index)
      break
    case 'overviewBlock':
      blockFactory = overviewBlockFactory(
        blockData,
        index,
        pagePath,
        culture,
        pageType,
      )
      break
    case 'cookieDeclaration':
      blockFactory = cookieDeclarationFactory(blockData, index)
      break
    case 'factCardSliderBlock':
      blockFactory = factCardSliderBlockFactory(blockData, index)
      break
    case 'ctaBlock':
      blockFactory = callToActionFactory(blockData, index)
      break
    case 'logoCarouselBlock':
      blockFactory = logoCarouselFactory(blockData, index)
      break
  }
  return blockFactory
}

export function ContentBlocks({
  blocksData,
  pagePath,
  pageType,
  homePageIdentifier,
  culture,
}: {
  blocksData: any
  pagePath: string
  pageType?: PageTypes
  homePageIdentifier?: string
  culture: Cultures,
}) {
  return (
    <>
      {blocksData.map((element: any, index: number) => {
        return getContentBlock(element, index, pagePath, culture, pageType)
      })}
    </>
  )
}
